const FLEX_SESSION_ID_KEY = "panelPortal.flexSessionId";

export function getFlexSessionId() {
  if (typeof window === "undefined") return null;
  const sessionId = window.localStorage.getItem(FLEX_SESSION_ID_KEY);
  const normalizedSessionId = sessionId?.trim();

  if (!normalizedSessionId) {
    window.localStorage.removeItem(FLEX_SESSION_ID_KEY);
    return null;
  }

  return normalizedSessionId;
}

export function setFlexSessionId(sessionId: string | null) {
  if (typeof window === "undefined") return;
  const normalizedSessionId = sessionId?.trim();
  // console.trace("setFlexSessionId", normalizedSessionId);
  if (normalizedSessionId) {
    window.localStorage.setItem(FLEX_SESSION_ID_KEY, normalizedSessionId);
    return;
  }
  window.localStorage.removeItem(FLEX_SESSION_ID_KEY);
}
